import React from 'react';
import PropTypes from 'prop-types';
import {styled} from '@mui/system';

import {autoPluralize} from '../../helpers/pluralizer';
import HighlightedItem from '../atoms/HighlightedItem';
import PreviewAndAll from '../organism/PreviewAndAll';
import BadgedTitle from '../atoms/BadgedTitle';


const StyledCities = styled('div')(({ theme }) =>({
    margin: 0,
    marginBottom: theme.custom.spacing.default
}));

const StyledCitiesList = styled('ul')(({ theme }) =>({
    paddingLeft: theme.custom.spacing.default,
    margin: 0
}));


class Cities extends React.Component {
    constructor(props) {
        super(props);
    }

    locationInfo = (city) => {
        let location_parts = [];
        if (city.state_name) {
            location_parts.push(city.state_name);
        }
        if (city.country_name) {
            location_parts.push(city.country_name);
        }
        if (location_parts.length) {
            return ' (' + location_parts.join(', ') + ')';
        }
        return '';
    };

    citiesList = (cities) => {
        return (
            <div>
                {cities && <StyledCitiesList>
                    {cities.map((city, index) =>
                        <li key={index}>
                            <HighlightedItem stats={city.stats} content={`${city.name}${this.locationInfo(city)}`} />
                        </li>
                    )}
                </StyledCitiesList>}
            </div>
        );
    };

    render() {
        const count = this.props.cities ? this.props.cities.length : 0;
        return (
            <StyledCities>
                <BadgedTitle title={autoPluralize(count, 'City', 'Cities')} match_details={this.props.match_details} />
                <PreviewAndAll data={this.props.cities} dataDisplayCallable={this.citiesList} />
            </StyledCities>
        );
    }

}

Cities.propTypes = {
    cities: PropTypes.array,
    match_details: PropTypes.object
};

export default Cities;
